import 'angular:locale/data:ko';
import '@angular/localize/init';(globalThis.$localize ??= {}).locale = "ko";
